import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { ContentService } from '../../services/content-service';

@Component({
  selector: 'app-footer',
  imports: [RouterLink],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer implements OnInit, OnDestroy {
  private unsubscribe = new Subject<void>();

  phone = '';
  email = '';

  @Input() copyrightYear: number = new Date().getFullYear();
  @Input() hideActions = false;

  constructor(private contentService: ContentService) { }

  ngOnInit(): void {
    this.contentService.footerContent
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(data => {
        this.phone = data?.phone ?? '';
        this.email = data?.email ?? '';
      });
    this.contentService.getFooterContent();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
